import React, { useEffect, useRef, useState } from 'react'
import { getLocMyJio } from '../../../utils/get-location'
import { useAvailableSlots } from "../store/stateProvider"
import useTranslation from '../../../hooks/use-translation';
import { fetchSessionsCalenderByDistrict, fetchSessionsCalenderByPin, fetchStatesOfIndia, fetchDistrictsOfIndia } from '../../../sources/slot-finder'
import { dtFormat } from '../../../utils/utils'
import Dropdown from '../dropdown'
import { isObjectEmpty } from '../../../utils/utils'
import { raiseGAEventForSlotFinder } from '../../../utils/network'
import TextField from '../textfield'
import { useHistory } from "react-router-dom";
import './user-input.css'

const validatePincode = pincodeVal => /^[1-9][0-9]{5}$/.test(pincodeVal)

const styles = {
  dataInputContainer: {
    width: '100%',
    minHeight: '12.9375em',
    background: '#fff',
    borderRadius: '5px',
    zIndex: 1
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    padding: '18px 0em 0em 0.9375em',
  },
  headerButton: {
    textDecoration: 'none',
    border: 'none',
    background: 'none',
    outline: 'none',
    width: '50%',
    fontFamily: 'JioType-Medium',
    fontSize: '12px',
    padding: '0.5em',
    borderBottom: '0.6px solid #D7D7D7'
  },
  cardNumberTextField: {
    width: '95%',
    fontSize: '16px',
    fontFamily: 'JioTypeW04-Light',
    border: '0',
    marginTop: '1em'
  },
  activeButton: {
    color: '#0028AF',
    borderBottom: '3px solid #0028AF'
  },
  inactiveButton: {
    color: '#7D7D7D'
  },
  textfieldDiv: {
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    padding: '0.5em 1em 0.5em 0.5em',
    border: '0.6px solid #D7D7D7',
    borderRadius: '10px',
    margin: '1em',
    marginBottom: '0',
    height: '3.25em'
  },
  errorTextMobile: {
    color: '#EB0000',
    marginLeft: '2em',
    textAlign: 'left',
    fontSize: '12px',
    position: 'absolute'
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    left: 0
  },
  buttonDivPincode: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonDivState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  searchButton: {
    width: '100%',
    height: '48px',
    border: '1px solid #0028AF',
    borderRadius: '10px',
    color: '#FFFFFF',
    background: '#0028AF',
    fontFamily: 'JioType-Medium',
    fontSize: '14px'
  },
  searchButtonState: {
    width: '100%',
    height: '48px',
    border: '1px solid #0028AF',
    borderRadius: '10px',
    color: '#FFFFFF',
    background: '#0028AF',
    fontFamily: 'JioType-Medium',
    fontSize: '14px'
  },
  dropdown: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '20px',
    marginBottom: '40px'
  },
  radioButton: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '3.75em',
    fontSize: '14px',
    fontFamily: 'jioType-Medium',
  },
  radioLabel: {
    marginLeft: '10px',
    marginBottom: '0px'
  },
  radio: {
    width: '20px',
    height: '20px',
    backgroundColor: '#ffffff'
  },
  buttonDisabled: {
    textTransform: 'none',
    height: '2em',
    width: '10em',
    border: 'none',
    backgroundColor: '#93BED8',
    color: '#ffffff',
    fontSize: '1em',
    fontFamily: 'jioType-Medium',
    outline: 'none',
    marginTop: '1em'

  },
  actionButton: {
    fontFamily: 'JioType-Medium',
    color: '#FFFFFF',
    fontSize: '16px',
    width: '10em',
    alignSelf: 'center',
    backgroundColor: '#214796',
    outline: 'none',
    height: '2em',
    border: 'none',
    marginTop: '1em'

  }
}
const UserInput = (props) => {
  const { closeDrawer = () => { } } = props
  const [data, dispatch] = useAvailableSlots()
  const { slots = {}, apiResponseCode = '', dateSlotsAvailable = true, initialSlots } = data
  const [pincode, setPincode] = useState('')
  const [buttonActive, setButtonActive] = useState({
    districtActive: false,
    pincodeActive: true
  })
  const [errorPincode, setErrorPincode] = useState('')
  const [errorState, setErrorState] = useState('')
  const [errorDistrict, setErrorDistrict] = useState('')
  const [stateList, setStateList] = useState({})
  const [districtList, setDistrictList] = useState({})
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [pinCodeFetched, setPinCodeFetched] = useState(false)
  const inputRef = useRef();
  const { t } = useTranslation();
  const history = useHistory()
  const [forceOpen, setForceOpen] = useState(false)
  const [showList, setShowList] = useState(false)
  const [showIcon, setShowIcon] = useState(false)

  const handleButtonClick = (e) => {
    const checkValue = e.target.value
    const unCheckValue = Object.keys(buttonActive).filter((val) => val.indexOf(checkValue) < 0)[0] || ''
    if (!buttonActive[`${checkValue}Active`]) {
      raiseGAEventForSlotFinder({
        eventAction: `Search by ${checkValue[0].toUpperCase() + checkValue.slice(1)}`,
        eventLabel: 'Click'
      })
      setErrorPincode('')
      setButtonActive({
        ...buttonActive,
        [`${checkValue}Active`]: true,
        [unCheckValue]: false
      })
    }
  }

  useEffect(() => {
    if (buttonActive.districtActive) {
      setForceOpen(true)
    }
  }, [buttonActive.districtActive])

  useEffect(() => {
    if (pinCodeFetched) {
      inputRef.current && inputRef.current.focus()
    }
  }, [pinCodeFetched, buttonActive.pincodeActive])

  const onTextChange = event => {
    const { value } = event.target
    setPincode(value)
  }

  const validatePin = (value) => {
    if (!value) {
      return t('ERROR_PINCODE_EMPTY')
    }
    if (!validatePincode(value))
      return t('ERROR_PINCODE_INVALID')
    return ''
  }

  const getDistrictObject = (districts = []) => {
    let districtObj = {}
    districts.length && districts.map((value, index) => {
      Object.assign(districtObj, { [' ' + value.district_id]: value.district_name });
    })
    return districtObj
  }

  useEffect(() => {
    if (selectedState)
      (async () => {
        try {
          const { districts = [] } = await fetchDistrictsOfIndia({ stateId: selectedState })
          const fetchedSDistricts = getDistrictObject(districts)
          setDistrictList(fetchedSDistricts)
        } catch (e) {
          console.log(e)
        }
      })()
  }, [selectedState])

  const onTextBlur = event => {
    const { value } = event.target
    let error = validatePin(value)
    setErrorPincode(error)
  }

  const validateEntries = (key, value) => {
    switch (key) {
      case 'district': {
        if (!value) {
          setErrorDistrict(t('ERROR_DISTRICT'))
          return true
        }
        setErrorDistrict('')
        return false
      }
      case 'state': {
        if (!value) {
          setErrorState(t('ERROR_STATE'))
          return true
        }
        setErrorState('')
        return false
      }
    }
  }

  const validateDistrictEntries = () => {
    const districtErr = validateEntries('district', selectedDistrict)
    const stateErr = validateEntries('state', selectedState)
    return districtErr || stateErr
  }

  const fetchDetails = async () => {

    try {
      let resp = {}
      const todaysDate = dtFormat(Date.now(), 'dd-MM-yyyy')
      if (buttonActive.districtActive) {
        const error = validateDistrictEntries()
        if (!error) {
          raiseGAEventForSlotFinder({ eventAction: 'Search', eventLabel: 'State entered' })
          dispatch({ type: 'SET_RESPONSE_CODE', apiResponseCode: 'pending' })
          resp = await fetchSessionsCalenderByDistrict({ districtId: selectedDistrict, date: todaysDate })
          if (!isObjectEmpty(resp)) {
            const { centers = [] } = resp
            dispatch({
              type: 'ADD_DETAILS',
              slots: centers,
              identifier: `${districtList[selectedDistrict]}, ${stateList[selectedState]}`,
              searchByPincode: false
            })
          }
          dispatch({ type: 'SET_RESPONSE_CODE', apiResponseCode: 'success' })
          closeDrawer()
        }
      } else {
        const error = validatePin(pincode)
        setErrorPincode(error)
        if (!errorPincode && !error) {
          raiseGAEventForSlotFinder({ eventAction: 'Search', eventLabel: 'Pincode entered' })
          dispatch({ type: 'SET_RESPONSE_CODE', apiResponseCode: 'pending' })
          resp = await fetchSessionsCalenderByPin({ pinCode: pincode, date: todaysDate })
          if (!isObjectEmpty(resp)) {
            const { centers = [] } = resp
            dispatch({ type: 'ADD_DETAILS', slots: centers, identifier: pincode, searchByPincode: true })
          }
          dispatch({ type: 'SET_RESPONSE_CODE', apiResponseCode: 'success' })
          closeDrawer()
        }
      }
    } catch (e) {
      setErrorPincode(t('ERROR_SLOT'))
      setErrorState(t('ERROR_SLOT'))
      dispatch({ type: 'SET_RESPONSE_CODE', apiResponseCode: 'failure' })
      console.log(e)
    }
  }

  useEffect(() => {
    if (apiResponseCode === 'success' || apiResponseCode === 'failure') {
      history.push('/vaccination-slot-finder/slot-list', data)
    }
  }, [apiResponseCode])

  const getStateObject = (states = []) => {
    let stateObj = {}
    states.length && states.map((value, index) => {
      Object.assign(stateObj, { [' ' + value.state_id]: value.state_name });
    })
    return stateObj
  }

  useEffect(() => {
    (async () => {
      try {
        const { pincode = '' } = await getLocMyJio()
        setPincode(pincode)
        const { states = [] } = await fetchStatesOfIndia()
        const fetchedState = getStateObject(states)
        setStateList(fetchedState)
      } catch (e) {
        setErrorPincode(t('ERROR_SLOT'))
        dispatch({ type: 'SET_RESPONSE_CODE', apiResponseCode: 'failure' })
        console.log(e)
      }
      setPinCodeFetched(true)
    })()
  }, [])

  const selectState = (state) => {
    validateEntries('state', state)
    if (state != selectedState) {
      setSelectedState(state)
      setShowIcon(true)
      setSelectedDistrict('')
    }
  }

  const selectDistrict = (district) => {
    validateEntries('district', district)
    setShowIcon(false)
    setSelectedDistrict(district)
  }

  useEffect(() => {
    if (buttonActive.pincodeActive) {
      props.collapse()
      setShowList(false)
      setSelectedState('')
      setSelectedDistrict('')
    }
    if (buttonActive.districtActive) {
      props.isExpand()
    }
    if (selectedState && selectedDistrict) {
      props.collapse()
    }
  }, [buttonActive.pincodeActive, selectedState, selectedDistrict])

  useEffect(() => {
    if (selectedState && buttonActive.districtActive) {
      setShowList(true)
    }
  }, [selectedState, buttonActive.districtActive])

  return (
    <div >
      <div style={styles.header}>
        <label style={styles.radioButton} className='rd_container'>
          <input type="radio" id="pincodeVaccineFinder" style={styles.radio} value="pincode"
            checked={buttonActive.pincodeActive === true} onClick={handleButtonClick} />
          <span className="checkmark" />
          {t('PIN_CODE')}
        </label>
        <label style={styles.radioButton} className='rd_container'>
          <input type="radio" id="districtVaccineFinder" style={styles.radio} value="district"
            checked={buttonActive.districtActive === true} onClick={handleButtonClick} />
          <span className="checkmark" />
          {t('DISTRICT')}
        </label>
      </div>
      {buttonActive.pincodeActive &&
        <>
          <div style={{ position: 'relative', margin: '1.25rem -1rem 2.5rem' }}>
            <TextField
              label={t('ENTER_PINCODE')}
              inputRef={inputRef}
              type='tel' maxLength='6'
              errorText={errorPincode}
              onBlur={onTextBlur}
              onChange={onTextChange}
              value={pincode}
            />
          </div>

          <div style={styles.buttonDivPincode}>
            <button value={t('SEARCH')} style={styles.searchButton} onClick={async () => { fetchDetails() }} >{t('SEARCH')} </button>
          </div>
        </>}
      {
        buttonActive.districtActive &&
        <>
          <div style={styles.dropdown}>
            <div>
              <Dropdown
                errorMsg={errorState}
                options={stateList}
                onClick={(value) => selectState(value)}
                value={stateList[selectedState]}
                label={t('STATE')}
                placeholderText={t('STATE')}
                showLoader={isObjectEmpty(stateList)}
                customePosition='relative'
                id='State'
                forceOpen={forceOpen}
              />
            </div>
            <div>
              <Dropdown
                errorMsg={errorDistrict}
                options={districtList}
                onClick={(value) => selectDistrict(value)}
                value={districtList[selectedDistrict]}
                label={t('DISTRICT')}
                placeholderText={t('DISTRICT')}
                showLoader={!!selectedState && isObjectEmpty(districtList)}
                customePosition='relative'
                id='District'
                showList={showList}
                showIcon={showIcon}
              />
            </div>
          </div>
          <div style={styles.buttonDiv}>
            <button value={t('SEARCH')} style={styles.searchButtonState} onClick={fetchDetails} >{t('SEARCH')} </button>
          </div>

        </>
      }
    </div >
  )
}

export default UserInput

